// extracted by mini-css-extract-plugin
module.exports = {"orderPreviewContainer":"styles_orderPreviewContainer__3OxJF","fullHeight":"styles_fullHeight__2pYQM","netnoticeButtonContainer":"styles_netnoticeButtonContainer__25KsF"};